import { createRouter, createWebHistory } from 'vue-router';
import { gtmPageView, pascalCase} from '../helpers';
import store from '@/store';
import { parseBingoCellFromQuery } from '@/utils/bingoCellUrl';

// Views
import Experiences from '@/views/Experiences/index.vue';
import Explore from '@/views/Explore/index.vue';
import Deal from '@/views/Deal/index.vue';
import Venue from '@/views/Venue/index.vue';
import Product from '@/views/Product/index.vue';
import Rewards from '@/views/Rewards/index.vue';
import ClaimReward from '@/views/Rewards/ClaimReward/index.vue';
import RewardsHistory from '@/views/Rewards/History/index.vue';
import More from '@/views/More/index.vue';
import Messages from '@/views/Messages/index.vue';
import Login from '@/views/Login/index.vue';
import Cart from '@/views/Cart/index.vue';
import Order from '@/views/Order/index.vue';
import OrderHistory from '@/views/Order/OrderHistory/index.vue';
import OrderDetails from '@/views/Order/OrderDetails/index.vue';
import ShippingInfo from '@/views/Rewards/ShippingInfo/index.vue';
import CommonQuestions from '@/views/More/Questions/index.vue';
import Subscriptions from '@/views/Subscriptions/index.vue';


const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/experiences',
    name: 'Experiences',
    component: Experiences,
    meta: { transition: 'slide-right' }
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: Rewards
  },
  {
    path: '/experiences/deal/:dealId',
    name: 'Deal',
    component: Deal,
    meta: { parent: 'Experiences' }
  },
  {
    path: '/experiences/deal/:dealId/venue/:venueId',
    name: 'DealVenue',
    component: Venue,
    meta: { parent: 'Experiences' }
  },
  {
    path: '/experiences/product/:productId',
    name: 'Product',
    component: Product,
    meta: { parent: 'Experiences' }
  },
  {
    path: '/experiences/venue/:venueId/product/:productId',
    name: 'VenueProduct',
    component: Product,
    meta: { parent: 'Experiences' }
  },
  {
    path: '/experiences/deal/:dealId/product/:productId',
    name: 'DealProduct',
    component: Product,
    meta: { parent: 'Experiences' }
  },
  {
    path: '/experiences/deal/:dealId/venue/:venueId/product/:productId',
    name: 'DealVenueProduct',
    component: Product,
    meta: { parent: 'Experiences' }
  },
  {
    path: '/account/messages',
    name: 'Messages',
    component: Messages,
    meta: { parent: 'More' }
  },
  {
    path: '/experiences/venue/:venueId/:tab?',
    name: 'Venue',
    component: Venue,
    meta: { parent: 'Experiences' }
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: Subscriptions
  },
  {
    path: '/explore',
    name: 'Explore',
    component: Explore
  },
  {
    path: '/revieworder',
    name: 'ReviewOrder',
    component: Order,
    meta: { parent: 'Cart' }
  },
  {
    path: '/orderhistory',
    name: 'OrderHistory',
    component: OrderHistory,
    meta: { parent: 'More' }
  },
  {
    path: '/orderdetails/:orderId',
    name: 'OrderDetails',
    component: OrderDetails,
    meta: { parent: 'Cart' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/rewards/:type/:typeId',
    name: 'ClaimReward',
    component: ClaimReward,
    meta: { parent: 'Rewards' }
  },
  {
    path: '/account/rewards',
    name: 'RewardsHistory',
    component: RewardsHistory,
    meta: { parent: 'More' }
  },
  {
    path: '/rewards/shippingInfo/:type/:typeId',
    name: 'ShippingInfo',
    component: ShippingInfo,
    meta: { parent: 'Rewards' }
  },
  {
    path: '/account/rewards/claimed',
    name: 'RewardsClaimed',
    component: RewardsHistory,
    meta: { parent: 'Rewards' }
  },
  {
    path: '/support/questions',
    name: 'CommonQuestions',
    component: CommonQuestions,
    meta: { parent: 'More' }
  },
  {
    path: '/account',
    name: 'More',
    component: More
  }
];
const router = createRouter({
  history: createWebHistory(window.bwBasePath),
  routes,
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const scroller = document.querySelector('.v-main__scroller');
        if (scroller) {
          scroller.scrollTop = 0;
          scroller.scrollLeft = 0;
        }
        resolve({ left: 0, top: 0 });
      }, 0);
    });
  }
});

/**
 * BEFORE EACH
 */
// router.beforeEach(async (to, from) => {

//   const isPreview = store.state?.offer?.isPreview || false;
  
//   // if (
//   //   isPreview &&
//   //   from.matched.length > 0 &&
//   //   ![
//   //     'Login',
//   //     // 'Product',
//   //     // 'Venue',
//   //     // 'VenueProduct',
//   //     // 'Deal',
//   //     // 'DealProduct',
//   //     // 'DealVenue',
//   //     // 'DealVenueProduct'
//   //   ].includes(to.name)
//   // ) {
//   //   return false; // cancel navigation
//   // }
// });

router.beforeEach(async (to, from) => {
  
  if (window.location.pathname.endsWith('signup')) return true

  const isPreview = store.state?.offer?.isPreview || false;

  // Ensure initial data is loaded
  if (!store.state.initialData?.ready) {
    await store.dispatch('initialData/getInitialData')
  }

  const offer = store.state.offer
  const isLoggedIn = store.state.auth.validated.validated
  const token = window.token


  /* -------- Preview routing -------- */
  if (offer.isPreview && to.name === 'Login') {
    let { previewType, previewTypeId } = offer

    if (!previewType || !previewTypeId) {
      return true
    }

    if (
      previewType === 'product' &&
      to.query.submissionVenueId
    ) {
      previewType = 'venue'
      previewTypeId = Number(to.query.submissionVenueId)
    }

    const target = {
      name: pascalCase(previewType),
      params: { [`${previewType}Id`]: previewTypeId },
      query: { t: token }
    }

    if (
      offer.previewDealId &&
      ['product', 'venue'].includes(previewType)
    ) {
      target.name = `Deal${target.name}`
      target.params.dealId = offer.previewDealId
    }

    if (!router.hasRoute(target.name)) {
      return offer.previewDealId
        ? {
            name: 'Deal',
            params: { dealId: offer.previewDealId },
            query: { t: token }
          }
        : { name: 'Experiences', query: { t: token } }
    }

    return target
  }

  /* -------- Normal auth routing -------- */
  if (!offer.isUnregisteredLink) {
    if (to.name === 'Login' && isLoggedIn) {      
      return { name: 'Experiences', query: { t: token } }
    }

    // Not logged in, return user to login page
    if (to.name !== 'Login' && !isLoggedIn) {      
      return { name: 'Login', query: { t: token } }
    }
  }

  if (
      isPreview &&
      from.matched.length > 0 &&
      ![
        'Login',
        'Product',
        'Venue',
        'VenueProduct',
        'Deal',
        'DealProduct',
        'DealVenue',
        'DealVenueProduct'
      ].includes(to.name)
    ) {
      return false; // cancel navigation
    }
})


/**
 * AFTER EACH
 */
router.afterEach((to, from) => {
  if (from.path !== '/') {
    gtmPageView(to);
  }

  const cell = parseBingoCellFromQuery(to.query);
  if (cell) {
    store.dispatch('bingo/setPendingBingoCell', cell);
  }
});

export default router;
